import React from "react";
import PropTypes from "prop-types";
import Tabs from "@material-ui/core/Tabs/Tabs";
import Tab from "@material-ui/core/Tab/Tab";
import Icon from "@material-ui/core/Icon/index";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  MuiTabRoot: {
    textTransform: "none",
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
  MuiTabWrapper: {
    flexDirection: "row",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  MuiTabLabelIcon: {
    minHeight: "50px",
  },
  MuiIconRoot: {
    paddingLeft: "9px",
  },
}));

const Stepper = (tabs) => {
  const [value, setValue] = useState(0);
  const classes = useStyles(props);

  handleChange = (event, value) => {
    setValue({ value });
  };

  return (
    <Tabs
      value={this.state.value}
      onChange={this.handleChange}
      indicatorColor={tabs.length > 1 ? "primary" : ""}
      centered
    >
      {tabs.map((tab) => {
        return [
          <Tab
            classes={{
              root: classes.MuiTabRoot,
              wrapper: classes.MuiTabWrapper,
              labelIcon: classes.MuiTabLabelIcon,
            }}
            key={tab.key}
            label={tab.title}
            icon={<Icon className={classes.MuiIconRoot}>{tab.icon}</Icon>}
          />,
        ];
      })}
    </Tabs>
  );
};

Stepper.propTypes = {
  classes: PropTypes.object,
  tabs: PropTypes.array,
};

export default Stepper;
